<template>
    <a href="#" v-on:click="showModal">CONFIGURAÇÃO DE PREFERÊNCIAS DE PRIVACIDADE</a>
</template>

<script>
    export default {
        name: "c-cp-link-modal-cookies-preferences",
        methods: {    
            showModal(e) {
                e.preventDefault();
                
                this.$store.dispatch('modalCookiesPreferences/showModal');
            },        
        },  
    }
</script>
